import { Component, OnInit } from "@angular/core";
import { formatMessage } from "devextreme/localization";

@Component({
  selector: "app-calculator-remastered",
  templateUrl: "./calculator-remastered.component.html",
  styleUrls: ["./calculator-remastered.component.scss"],
})
export class CalculatorRemasteredComponent implements OnInit {
  constructor() {}

  showToast: boolean = false;
  toastMessage: string = "For some reason we need an initial value here...";
  toastType: string = "default";

  formatMessage = formatMessage;

  ngOnInit(): void {}
}
